import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import { showErrorNotification } from '../actions/App';
import * as actions from '../actions/Buses';
import * as busesApi from '../api/Buses';
import {
  GET_BUSES_BY_CARRIER_ID,
  GET_CARRIER_BUS_LIST,
  CREATE_BUS,
  UPDATE_BUS,
  REMOVE_BUS,
  GET_BUS_LOCATIONS,
  GET_AGENDA_BUS_LOCATION,
} from '../constants/ActionTypes';
import { extractBusLocations } from 'util/BusLocationsUtils';

const todayRoutesSelector = state => state.routes.activeRoutes;

function* getBusesByCarrierId({ payload }) {
  yield put(actions.setBusesByCarrierIdLoading(payload.carrierId, true));

  try {
    const { data } = yield call(busesApi.getBusesByCarrierId, payload.carrierId);
    yield put(actions.getBusesByCarrierIdSuccess(payload.carrierId, data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  } finally {
    yield put(actions.setBusesByCarrierIdLoading(payload.carrierId, false));
  }
}

function* getCarrierBusList({ payload }) {
  yield put(actions.setBusListLoading(true));

  try {
    const { data } = yield call(busesApi.getBusesByCarrierId, payload.carrierId);
    yield put(actions.getBusListSuccess({ entities: data, pageCount: 0 }));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
  yield put(actions.setBusListLoading(false));
}

function* createBus({ payload }) {
  try {
    const { data } = yield call(busesApi.createBus, payload.carrierId, payload.bus);

    yield put(actions.createBusSuccess(data));
  } catch (error) {
    yield put(actions.updateBusFailure());
    yield put(showErrorNotification(error.messages));
  }
}

function* updateBus({ payload }) {
  try {
    const { data } = yield call(busesApi.updateBus, payload.carrierId, payload.busId, payload.bus);

    yield put(actions.updateBusSuccess(data));
  } catch (error) {
    yield put(actions.updateBusFailure());
    yield put(showErrorNotification(error.messages));
  }
}

function* removeBus({ payload }) {
  try {
    yield call(busesApi.removeBus, payload.busId);

    yield put(actions.removeBusSuccess(payload.busId));
  } catch (error) {
    yield put(actions.updateBusFailure());
    yield put(showErrorNotification(error.messages));
  }
}

function* getBusLocations({ payload }) {
  // are we locating specific buses (route detials or overview selection filter)
  if (payload.busesIds && payload.busesIds.length) {
    try {
      const { data } = yield call(busesApi.getBusLocations, payload.busesIds);
      yield put(actions.getBusLocationsSuccess(data.locations));
    } catch (error) {
      yield put(showErrorNotification(error.messages));
    }
  } else {
    // are we in overview with nothing selected for filters
    const todayRoutes = yield select(todayRoutesSelector);
    const busesWithLocations = extractBusLocations(todayRoutes);
    if (busesWithLocations.length) {
      try {
        const { data } = yield call(busesApi.getBusLocations, payload.busesIds);
        yield put(actions.getBusLocationsSuccess(data.locations));
      } catch (error) {
        // catch error for staging and prod temporarily - remove this retry later on release of server
        const busIdsToLocate = busesWithLocations.map(location => location.busId);
        console.log('getBusLocations', `Using TodayRoute buses ${busIdsToLocate.length}`);
        try {
          const { data } = yield call(busesApi.getBusLocations, busIdsToLocate);
          yield put(actions.getBusLocationsSuccess(data.locations));
        } catch (error2) {
          yield put(showErrorNotification(error2.messages));
        }
      }
    } else {
      console.log('getBusLocations', 'No buses to locate');
      yield put(actions.getBusLocationsSuccess([]));
    }
  }
}

// function* getBusLocations({ payload }) {
//   if (payload.busesIds && payload.busesIds.length) {
//     try {
//       const { data } = yield call(busesApi.getBusLocations, payload.busesIds);
//       yield put(actions.getBusLocationsSuccess(data.locations));
//     } catch (error) {
//       yield put(showErrorNotification(error.messages));
//     }
//   } else {
//     const todayRoutes = yield select(todayRoutesSelector);
//     const busIdsToLocate = extractBusLocations(todayRoutes).map(location => location.busId);
//     if (busIdsToLocate.length) {
//       console.log('getBusLocations', `Using TodayRoute buses ${busIdsToLocate.length}`);
//       try {
//         const { data } = yield call(busesApi.getBusLocations, busIdsToLocate);
//         yield put(actions.getBusLocationsSuccess(data.locations));
//       } catch (error) {
//         yield put(showErrorNotification(error.messages));
//       }
//     } else {
//       console.log('getBusLocations', 'No buses to locate');
//       yield put(actions.getBusLocationsSuccess([]));
//     }
//   }
// }

function* getAgendaBusLocation({ payload }) {
  try {
    const { data } = yield call(busesApi.getAgendaBusLocation, payload.busId);

    yield put(actions.getAgendaBusLocationSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

export function* getBusesByCarrierIdSaga() {
  yield takeLatest(GET_BUSES_BY_CARRIER_ID, getBusesByCarrierId);
}

export function* getCarrierBusListSaga() {
  yield takeLatest(GET_CARRIER_BUS_LIST, getCarrierBusList);
}

export function* createBusSaga() {
  yield takeLatest(CREATE_BUS, createBus);
}

export function* updateBusSaga() {
  yield takeLatest(UPDATE_BUS, updateBus);
}

export function* removeBusSaga() {
  yield takeLatest(REMOVE_BUS, removeBus);
}

export function* getBusLocationsSaga() {
  yield takeLatest(GET_BUS_LOCATIONS, getBusLocations);
}

export function* getAgendaBusLocationSaga() {
  yield takeLatest(GET_AGENDA_BUS_LOCATION, getAgendaBusLocation);
}

export default function* rootSaga() {
  yield all([
    fork(getBusesByCarrierIdSaga),
    fork(getCarrierBusListSaga),
    fork(createBusSaga),
    fork(updateBusSaga),
    fork(removeBusSaga),
    fork(getBusLocationsSaga),
    fork(getAgendaBusLocationSaga),
  ]);
}
